import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideUpdateStations = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkRideUpdateStationsProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideUpdateStations,
    entity,
  );

  const bulkRideUpdateStationsProcess = useRecoilValue(
    activeProcessSF(bulkRideUpdateStationsProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideUpdateStations,
      toastSummaryOnComplete: true,
      process: bulkRideUpdateStationsProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [
    bulkRideUpdateStationsProcess,
    entity,
    onComplete,
    stopProcessPolling,
    t,
  ]);
};
